import { useQuery } from '@tanstack/react-query';
import { apiGetLocalization } from 'lib/api';
import { SUPPORTED_MARKETS } from 'lib/utils/get-market-country';

export type MarketCountry = {
  isoCode: string;
  name: string;
  currency: { isoCode: string; name: string; symbol: string };
};

export const useAvailableMarkets = (): MarketCountry[] => {
  const { data } = useQuery({
    queryKey: ['available-markets'],
    queryFn: async () => {
      const res = await apiGetLocalization();
      if (res.status !== 200 || !res.data?.availableCountries) {
        return [];
      }
      const countries = res.data.availableCountries as MarketCountry[];
      // A non-US country still priced in USD has no configured Shopify
      // market yet — hide it from the selector until it has its own currency.
      return countries.filter(
        (country) =>
          SUPPORTED_MARKETS.includes(country.isoCode) &&
          (country.isoCode === 'US' || country.currency.isoCode !== 'USD'),
      );
    },
    staleTime: 60 * 60 * 1000,
  });

  return data ?? [];
};
